import {useEffect} from 'react'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {Box, Flex} from '@chakra-ui/react'
import {Layout} from 'antd'
import {LOCAL_STORAGE, PATH, SESSION_STORAGE} from '@utils/Const'
import {useDispatch, useSelector} from 'react-redux'
import {appInit} from '@redux/app/appSlice'
import {getUserId, initTracking, isLoggedIn} from '@utils'
import Sidebar from '@components/Sidebar'
import UpgradeModal from '@components/UpgradeModal'
import {
  getFeedbackOverview,
  updateIsShowModalExitFlow,
} from '@redux/shared/shared'
import ModalExitFlow from '@components/ModalExitFlow/ModalExitFlow'
import GoogleTagManagerScript from './../../google-tag-manager-script'
import appRequest from '@apis/app'
const {Content} = Layout

function AuthLayout() {
  const location = useLocation()
  const dispatch: any = useDispatch()
  const navigate = useNavigate()
  const {isFinishRoadMap} = useSelector((state: any) => state.map) || {}
  const {userId} = useSelector((state: any) => state.app) || {}
  const userID = userId || getUserId()

  const routesWithHeader = [
    PATH.LEARN,
    PATH.EXAM,
    PATH.EXAM_HISTORY,
    PATH.HOME,
    PATH.LESSON_LEARN,
    PATH.GYM,
    PATH.GYM_VOCABULARY,
    PATH.LEARN_NOTEBOOK,
    PATH.LEARN_REVISE,
    PATH.LEARN_REVISE_ROOM_COMPLETE,
    PATH.LEARN_REVISE_SENTENCE_RESULT,
    PATH.LEARN_REVISE_SENTENCE_OVERVIEW,
  ]

  const publicRoutes = [
    PATH.HOME,
    PATH.LEARN,
    PATH.GYM,
    PATH.EXAM,
    PATH.CONVERSATION,
    PATH.ROADMAP_SUMMARY,
  ]

  const isNavigationRoute = (path: string) => routesWithHeader.includes(path)
  const isHomePathWithFinishedRoadMap = (path: string) =>
    path === PATH.HOME && isFinishRoadMap

  const isShowHeader =
    isNavigationRoute(location.pathname) &&
    (location.pathname !== PATH.HOME ||
      isHomePathWithFinishedRoadMap(location.pathname))

  const isNoLimitWidth =
    location.pathname === PATH.LEARN ||
    location.pathname === PATH.GYM ||
    location.pathname === PATH.EXAM ||
    location.pathname === PATH.LESSON_LEARN

  async function init() {
    if (!(!userID && !isLoggedIn())) {
      // @ts-ignore
      initTracking(userID)
      return
    }
    // @ts-ignore
    dispatch(appInit())
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    const userName = localStorage.getItem(LOCAL_STORAGE.USER_NAME)
    if (isLoggedIn() && !userName) {
      const getUserDetails = async () => {
        const res = await appRequest.getUserDetails()
        const {email, name, phone} = res?.data?.data
        localStorage.setItem(LOCAL_STORAGE.USER_EMAIL, email)
        localStorage.setItem(LOCAL_STORAGE.USER_NAME, name)
        localStorage.setItem(LOCAL_STORAGE.USER_PHONE, phone)
      }
      getUserDetails()
    }
  }, [])

  useEffect(() => {
    if (!userID) return
    dispatch(getFeedbackOverview())
    const isCheckDevice = sessionStorage.getItem(
      SESSION_STORAGE.IS_CHECK_DEVICE,
    )
    if (!isCheckDevice) {
      appRequest.checkDevice(userID).then(() => {
        sessionStorage.setItem(SESSION_STORAGE.IS_CHECK_DEVICE, 'true')
      })
    }
  }, [userID])

  useEffect(() => {
    dispatch(updateIsShowModalExitFlow(false))
  }, [location])

  useEffect(() => {
    if (!isLoggedIn() && !publicRoutes.includes(location.pathname)) {
      // Redirect to login page if not authenticated
      navigate(PATH.LOGIN, {replace: true})
    }
  }, [location])

  return (
    <Layout style={{height: '100%'}}>
      <Content className="content-layout" style={{height: '100%'}}>
        <Flex
          maxW={isShowHeader ? (isNoLimitWidth ? 'unset' : '1600px') : 'unset'}
          h="100%"
          minH="100dvh"
          mx="auto"
          flexDirection="column">
          {isShowHeader && <Sidebar init={init} />}
          <Box flex={1} h="100%" ml={isShowHeader ? {base: 0, md: '256px'} : 0}>
            {userID && <Outlet />}
          </Box>
        </Flex>
        <UpgradeModal />
        <ModalExitFlow />
      </Content>
      <GoogleTagManagerScript />
    </Layout>
  )
}

export default AuthLayout
